<template>
  <div class="bg-grey-lighten-3" style="min-height: 100vh">
    <div class="primerica-logo-container">
      <v-img src="../assets/primerica-logo.svg" alt="" class="primerica-logo mx-auto" width="260" />
    </div>
    <div class="px-15 py-5">
      <p class="mt-5">
        <strong>We can’t find that page. </strong>
      </p>
      <p class="mt-5">
        <strong
          >The web address may be incomplete or entered incorrectly. Let’s get you where you need to
          go.
        </strong>
      </p>
      <p class="mt-5">
        <strong>Try one of the options below:</strong>
      </p>
      <ul class="mt-5">
        <li>Scan the QR code provided to access the correct page</li>
        <li>Double check the web address and try again</li>
        <li>Contact the Primerica representative who shared the link and ask them to resend it</li>
      </ul>
    </div>
  </div>
</template>
